<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Add Coupon</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

<div class="add_new_md">
<mat-dialog-content>
    <form [formGroup]="addDiscountForm" (ngSubmit)="saveDiscount()">
        <div class="add_scroll">
            <div class="ad_ox">
              

                <div class="inline_fit">
                <mat-form-field appearance="outline">
                    <mat-label>Coupon code</mat-label>
                    <input matInput id="couponCode" autocomplete="off" formControlName="title" placeholder="Enter title">
                  </mat-form-field>
                </div>

                <div class="add_lil">
                    <mat-radio-group aria-label="Select an option" formControlName="coupon_type">
                        <label for="dfsd" class="mjy_she">Coupon type*</label><br>
                        <mat-radio-button  id="test001" [value]="1"  >Booking</mat-radio-button>
                        <mat-radio-button  id="test002" [value]="2" >Membership</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="inline_fit" *ngIf="addDiscountForm.value.coupon_type == 2">
                    <mat-form-field appearance="outline">
                        <mat-label>Coupon use limit</mat-label>
                        <input matInput id="discount" autocomplete="off" formControlName="membership_use_limit" placeholder="No. of invoice (0 for unlimited)">
                      </mat-form-field>
                </div>

                <div class="form-group">
                    <label for="Description" class="coupons_rty">Coupon available on*</label>
                    <div class="add_crt">
                        <div class="row">
                            <div class="col-sm-4 try" *ngIf="shop_status != '2'">
                                <mat-checkbox id="testing1" value="shop" formControlName="couponApplyShopType" class="example-margin" (change)="clickCheckbox($event.checked)" ></mat-checkbox>
                                <label for="testing1" class="check-label">Shop</label>
                            </div>
                            <div class="col-sm-4" *ngIf="home_status != '2'">
                                <mat-checkbox id="testing2" value="home" formControlName="couponApplyHomeType" class="example-margin"  ></mat-checkbox>
                                <!-- <input type="radio" id="testing2" value="home" formControlName="couponApplyType"> -->
                                <label for="testing2" class="check-label">Home</label>
                            </div>
                            <div class="col-sm-4" *ngIf="virtual_status != '2'">
                                <mat-checkbox id="testing3" value="virtual" formControlName="couponApplyVirtualType" class="example-margin"  ></mat-checkbox>
                                <!-- <input type="radio" id="testing2" value="home" formControlName="couponApplyType"> -->
                                <label for="testing3" class="check-label">Virtual</label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group">
                    <label for="Description" class="mjy_she">Discount apply type*</label>
                    <div class="add_crt">
                        <div class="row">
                            <div class="col-sm-3">
                                <input type="radio" id="test1" value="percent" formControlName="discountApplyType" (click)="changeDiscType($event)">
                                <label for="test1">Percentage</label>
                            </div>
                            <div class="col-sm-9">
                                <input type="radio" id="test2" value="amount" formControlName="discountApplyType" (click)="changeDiscType($event)">
                                <label for="test2">Amount</label>
                            </div>
                        </div>
                    </div>
                </div> -->

            <div class="add_lil">
                <mat-radio-group aria-label="Select an option" formControlName="discountApplyType">
                    <label for="Description" class="mjy_she">Discount apply type*</label><br>
                    <mat-radio-button  id="test1" value="percent"  >Percentage</mat-radio-button>
                    <mat-radio-button  id="test2" value="amount" >Amount</mat-radio-button>
                </mat-radio-group>
            </div>
                
                <!-- <strong *ngIf="addDiscountForm.get('discountApplyType').invalid && addDiscountForm.get('discountApplyType').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
                <!-- <div class="form-group">
                    <label for="Mobile">Discount value</label>
                    <input type="text" id="cost" autocomplete="off" formControlName="discountValue" placeholder="Enter discount value">
                </div> -->

                <div class="inline_fit">
                    <mat-form-field appearance="outline">
                        <mat-label>Discount value</mat-label>
                        <input matInput id="cost" autocomplete="off" formControlName="discountValue" placeholder="Enter discount value">
                      </mat-form-field>
                    </div>

                    <div class="inline_fit">
                        <mat-form-field appearance="outline">
                            <mat-label>Minimum cart value *</mat-label>
                            <input matInput id="type" autocomplete="off" formControlName="minimumCartValue" placeholder="Enter minimum cart value">
                          </mat-form-field>
                        </div>

                        <div class="inline_fit" *ngIf="addDiscountForm.value.discountApplyType == 'percent'">
                            <mat-form-field appearance="outline">
                                <mat-label>Maximum discount amount *</mat-label>
                                <input matInput id="discount" autocomplete="off" formControlName="maximumDiscountAmount" placeholder="Enter Maximum discount amount">
                              </mat-form-field>
                            </div>

                        <div class="inline_fit" >
                             <mat-form-field appearance="outline">
                                    <mat-label>No. of coupons*</mat-label>
                                 <input matInput  id="access" autocomplete="off" formControlName="maximumAccess" placeholder="Total coupons to be created">
                            </mat-form-field>
                        </div>

                     

                       <!-- Start Date Field -->
<div class="inline_fit">
    <mat-form-field appearance="outline">
      <mat-label>Start date*</mat-label>
      <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Choose a start date">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <!-- <strong *ngIf="addDiscountForm.get('startDate').invalid && addDiscountForm.get('startDate').touched" style="color: red; font-size: small">
      Field is mandatory
    </strong> -->
  </div>
  
  <!-- Expiry Date Field -->
  <div class="inline_fit">
    <mat-form-field appearance="outline">
      <mat-label>Expiry date*</mat-label>
      <input matInput [matDatepicker]="expiryPicker" formControlName="expiryDate" placeholder="Choose an expiry date">
      <mat-datepicker-toggle matSuffix [for]="expiryPicker"></mat-datepicker-toggle>
      <mat-datepicker #expiryPicker></mat-datepicker>
    </mat-form-field>
    <!-- <strong *ngIf="addDiscountForm.get('expiryDate').invalid && addDiscountForm.get('expiryDate').touched" style="color: red; font-size: small">
      Field is mandatory
    </strong> -->
  </div>
  
               <div class="inline_fit">
                <mat-form-field appearance="outline">
                  <mat-label>Description*</mat-label>
                  <textarea matInput rows="4" cols="50" id="Notes" autocomplete="off" formControlName="description" placeholder="Enter coupon description"></textarea>
                </mat-form-field>
              </div>
              



                <!-- <strong *ngIf="addDiscountForm.get('discountValue').invalid && addDiscountForm.get('discountValue').touched" style="color: 'red'; font-size: small">Enter valid discount value</strong> -->
                <!-- <div class="form-group">
                    <label for="email">Minimum cart value *</label>
                    <input type="text" id="type" autocomplete="off" formControlName="minimumCartValue" placeholder="Enter minimum cart value">
                </div> -->
                <!-- <div class="form-group" *ngIf="discountType == true">
                    <label for="email">Maximum discount amount *</label>
                    <input type="text" id="discount" autocomplete="off" formControlName="maximumDiscountAmount" placeholder="Enter Maximum discount amount">
                </div> -->
                <!-- <strong *ngIf="addDiscountForm.get('minimumCartValue').invalid && addDiscountForm.get('minimumCartValue').touched" style="color: 'red'; font-size: small">Enter valid minimum cart value</strong> -->
                <!-- <div class="form-group">
                    <label for="access">Maximum times of access*</label>
                    <input smDecimalOnly type="number" id="access" autocomplete="off" formControlName="maximumAccess" placeholder="Enter Maximum times of coupon access">
                </div> -->
                
                <!-- <div class="form-group">
                    <label for="Description">Start date*</label>
                    <input type="date" name="date" formControlName="startDate">
                </div> -->
                <!-- <strong *ngIf="addDiscountForm.get('startDate').invalid && addDiscountForm.get('startDate').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
                <!-- <div class="form-group">
                    <label for="Description">Expiry date*</label>
                    <input type="date" name="date" formControlName="expiryDate">
                </div> -->
                <!-- <strong *ngIf="addDiscountForm.get('expiryDate').invalid && addDiscountForm.get('expiryDate').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
                <!-- <div class="form-group">
                <label for="Description">Number of times Access*</label>
                <input type="text" autocomplete="off" formControlName="noOfTimeAccess" placeholder="Enter number of times access">
            </div>
            <strong *ngIf="addCouponForm.get('noOfTimeAccess').invalid && addCouponForm.get('noOfTimeAccess').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
                <!-- <div class="form-group">
                    <label for="Description">Description*</label>
                    <textarea rows="4" cols="50" id="Notes" autocomplete="off" formControlName="description" placeholder="Enter coupon description"></textarea>
                </div> -->
                <!-- <strong *ngIf="addDiscountForm.get('description').invalid && addDiscountForm.get('description').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
            </div>
        </div>

        <!-- <div class="add_footer">
            <div class="md-footer">
                <div class="row">
                    <div class="col-sm-6">
                    </div>
                    <div class="col-sm-3">
                        <button type="button" class="cenl_btn" (click)="closePopup()">Cancel</button>
                    </div>
                    <div class="col-sm-3">
                        <button type="submit" [disabled]="addDiscountForm.invalid">Add Discount</button>
                    </div>
                </div>
            </div>
        </div> -->
    </form>
    
</mat-dialog-content>
</div>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="addDiscountForm.invalid"
      (click)="saveDiscount()"
    >
      Create
    </button>
  </mat-dialog-actions>